import { createContext, useContext, useMemo } from "react";
import { ApolloProvider } from "@apollo/client/react";
import { type ApolloClient, type NormalizedCacheObject } from "@apollo/client";
import Loading from "../Loading";
import { ConfigContext } from "../Config";
import gqlClientConnect from "src/api-config/graphql.config";


const webSocketDefaultValue = {
  state: false,
  setState: (state: boolean) => { }
};

export const WebsocketContext = createContext(webSocketDefaultValue);

type ApolloProps = {
  children: React.ReactNode;
  initialState?: NormalizedCacheObject;
  /** Render children without a client until config arrives, instead of the loading screen. For error pages. */
  renderBeforeReady?: boolean;
};

export default function Apollo({ children, initialState, renderBeforeReady = false }: Readonly<ApolloProps>) {
  const { state: config } = useContext(ConfigContext);

  const client = useMemo<ApolloClient | null>(() => {
    if (!config) return null;
    return gqlClientConnect(config.httpURL, initialState);
  }, [config, initialState]);

  if (!client) {
    return renderBeforeReady ? <>{children}</> : <Loading />;
  }

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
}
